'use strict';

class DnsResolver {
    resolve (type, domain) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: 'GET',
                url: 'https://dns.google/resolve?type=' + type + '&name=' + domain,
                success: data => {
                    let response = data;
                    try {
                        if (typeof data === 'string' || data instanceof String) {
                            response = JSON.parse(data);
                        }
                    } catch (err) {
                        console.error('Error while trying to resolve domain', err);
                    }
                    resolve(response);
                },
                error: data => {
                    let response = data;
                    try {
                        if (typeof data === 'string' || data instanceof String) {
                            response = JSON.parse(data);
                        }
                    } catch (err) {
                        console.error('Error while trying to resolve domain', err);
                    }
                    reject(response);
                }
            });
        });
    };
};

class DnsValidator {
    constructor (response) {
        this.response = response;
    }

    isValidDomain () {
        let valid = false;
        if ('Answer' in this.response) {
            const answer = this.response['Answer'];
            if (Array.isArray(answer)) {
                if (answer.length > 0) {
                    valid = true;
                    if (answer.length === 1 && answer[0].data.includes('localhost.')) {
                        valid = false;
                    }
                }
            }
        }
        return valid;
    }
};

module.exports = {
    DnsResolver: new DnsResolver(),
    DnsValidator: DnsValidator
};
